import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=071a7f13&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ALEX\\Desktop\\pokemon_card_shipping\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-071a7f13"]])

export default __exports__